<template>
  <generic-container
    v-bind:searchable="false"
    v-bind:show_plus="false"
    icon="calendar"
    :title="$t('days')"
    v-on:add="add_day"
  >
    <div
      class="fields"
      style="margin-bottom:5px"
      v-for="(schedule, index) in schedules"
      v-bind:key="index"
    >
      <div class="four column wide field">
        <label v-show="index == 0">{{ $t("day") }}</label>
        <label>{{ schedule.name }}</label>
        <!-- <h4>{{ schedule.name }}</h4> -->
        <!-- <input type="text" name="name" v-model="schedules[index].name" /> -->
      </div>
      <div class="twelve column wide field">
        <label v-show="index == 0">{{ $t("studying time") }}</label>
        <select
          multiple
          class="ui multiple search selection dropdown"
          v-model="schedules[index].studying_times"
          ref="studying_times"
        >
          <option
            v-for="(st, sidx) in studying_times"
            :key="sidx"
            :value="st.studying_time_id"
          >
            {{ st.name }}</option
          >
        </select>
        <!-- <div class="ui multiple search selection dropdown" ref="studying_times">
          <input
            name="type"
            type="hidden"
            v-model="schedules[index].studying_times"
          />
          <i class="dropdown icon"></i>
          <div class="default text">{{ $t("studying times") }}</div>
          <div class="menu">
            <div
              class="item"
              v-for="(st, sidx) in studying_times"
              :key="sidx"
              :value="st.studying_time_id"
            >
              {{ st.name }}
            </div>
          </div>
        </div> -->
      </div>
      <!-- <div class="two column wide field">
        <label v-show="index == 0">{{ $t("delete") }}</label>
        <div class="ui red icon button" v-on:click="remove(index)">
          <i class="trash icon"></i>
        </div>
      </div> -->
    </div>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer";
import { local_api, error_toast } from "@/utils";
import { v4 } from "uuid";

export default {
  name: "CourseAssignationConfigurationModalSchedules",
  components: {
    GenericContainer,
  },
  data() {
    return {
      schedules: [
        {
          day_index: 0,
          name: this.$t("monday"),
          studying_times: [],
        },
        {
          day_index: 1,
          name: this.$t("tuesday"),
          studying_times: [],
        },
        {
          day_index: 2,
          name: this.$t("wednesday"),
          studying_times: [],
        },
        {
          day_index: 3,
          name: this.$t("thursday"),
          studying_times: [],
        },
        {
          day_index: 4,
          name: this.$t("friday"),
          studying_times: [],
        },
        {
          day_index: 5,
          name: this.$t("saturday"),
          studying_times: [],
        },
        {
          day_index: 6,
          name: this.$t("sunday"),
          studying_times: [],
        },
      ],
      studying_times: [],
    };
  },
  methods: {
    add_day() {
      let vm = this;
      vm.schedules.push({
        uuid: v4(),
        name: "",
        studying_times: [],
      });
    },
    remove(index) {
      let vm = this;
      vm.schedules.splice(index, 1);
    },
    getList() {
      return this.schedules;
    },
    setList(list) {
      let vm = this;
      list.map((itm, idx) => {
        if (itm.studying_times && itm.studying_times.length)
          window
            .jQuery(vm.$refs.studying_times[idx])
            .dropdown("set selected", itm.studying_times);
      });
    },
  },
  mounted() {
    let vm = this;
    local_api(
      vm,
      "post",
      "/student_configuration/do-get-studying-time-list",
      {},
    )
      .then((list) => {
        vm.studying_times = list;
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  updated() {
    let vm = this;
    // let vls = vm.studying_times.map((s) => {
    //   return { name: s.name, value: s.studying_time_id };
    // });
    window.jQuery(vm.$refs.studying_times).dropdown();
    // .dropdown("setup menu", { values: vls })
    // .dropdown({
    //   onChange(value, text, $element) {
    //     console.log(value, $element);
    //   },
    // });
  },
};
</script>
